import { useCallback, useState } from 'react';

/**
 * Whether the 3D scene crashed on the twin now showing. A crash is not a load: the page clears its
 * loading spinner so the panels still appear, but nothing that waits for the models (the spotlight
 * fly-to) is told they loaded. Any twin change clears it, including a return to the twin that
 * crashed — the scene `ErrorBoundary` resets on the same change and draws that twin afresh, so it
 * must load (or crash) again before the spinner clears.
 */
export const useSceneCrash = (twinBId: string | null) => {
  const [crash, setCrash] = useState({ twinBId, crashed: false });
  // Reset during render on a twin change (React's "adjusting state when a prop changes"), so no
  // render ever reports the previous twin's crash.
  if (crash.twinBId !== twinBId) setCrash({ twinBId, crashed: false });
  const onCrash = useCallback(() => setCrash({ twinBId, crashed: true }), [twinBId]);
  return { crashed: crash.crashed, onCrash };
};
